<footer class="footertag">
  <div class="h-section-boxed-container">
    <div class="h-row justify-content-lg-center">
      <div class="style-local-4581-f26-outer">
        <div class="v-inner-lg-1 v-inner-md-1 v-inner-1 style-7866">
          <div class="style-7872">
            <p class="footer-text">
              Copyright {{ currentYear }} by
              <a href="https://www.stpub.com" class="footer-link-text"
                >STP ComplianceEHS</a
              >. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
      <div
        class="style-7873 v-inner-lg-1 v-inner-md-1 v-inner-1 style-7867 style-local-4581-f28-outer"
      >
        <p class="footer-text">
          <a
            href="https://stpub.com/privacy"
            target="_blank"
            class="footer-link"
            rel="noopener"
            >PRIVACY POLICY&nbsp;</a
          >
          <a
            href="https://stpub.com/terms"
            target="_blank"
            class="footer-link"
            rel="noopener"
            >TERMS OF USE</a
          >
          <a
            href="https://stpub.com/eula"
            target="_blank"
            class="footer-link"
            rel="noopener"
            >LICENSE AGREEMENT</a
          >
          <a
            href="https://stpub.com/cookies"
            target="_blank"
            class="footer-link"
            rel="noopener"
            >COOKIE POLICY</a
          >
          <a
            href="https://www.stpub.com/wp-content/uploads/STP-ComplianceEHS-–-Government-Works-Notice.pdf"
            class="footer-link"
            target="_blank"
          >
            GOVERNMENT&nbsp;WORKS&nbsp;NOTICE
          </a>
        </p>
      </div>
    </div>
  </div>
</footer>
